import { useEffect, useState } from 'react';

const ESTIMATED_DURATION_MS = 30000;

/**
 * Mirrors RovoThinkingBar's useProgressFacade loading phase. The shared session
 * start and target keep this bar aligned with the floating editor bar, including
 * when the panel opens mid-review. Keep the duration aligned with platform.
 */
export function useSuggestionsLoadingProgress({
	startedAt,
	progressTarget,
}: {
	startedAt?: number | null;
	progressTarget?: number | null;
}): number {
	const [fallbackTarget] = useState(() => 85 + Math.random() * 10);
	const target = progressTarget ?? fallbackTarget;
	const [progress, setProgress] = useState(() =>
		startedAt == null
			? 0
			: Math.min(1, Math.max(0, Date.now() - startedAt) / ESTIMATED_DURATION_MS) * target,
	);

	useEffect(() => {
		const sessionStart = startedAt ?? Date.now();
		let frameId: number;
		const tick = () => {
			const fraction = Math.min(1, Math.max(0, Date.now() - sessionStart) / ESTIMATED_DURATION_MS);
			setProgress(fraction * target);
			if (fraction < 1) {
				frameId = requestAnimationFrame(tick);
			}
		};

		frameId = requestAnimationFrame(tick);
		return () => cancelAnimationFrame(frameId);
	}, [startedAt, target]);

	return progress;
}
